import React from "react";
import styled from "styled-components";
import { css } from "../styled";

type PageWrapperLayoutVariant = "default" | "narrow";
type PageWrapperBackgroundColor = "gray" | "white";

interface Props {
  header?: React.ReactNode;
  footer?: React.ReactNode;
  bgColor?: PageWrapperBackgroundColor;
  children: React.ReactNode;
  variant?: PageWrapperLayoutVariant;
}

const Wrapper = styled.div<{ $bgColor: PageWrapperBackgroundColor }>`
  ${({ theme, $bgColor }) => css`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    height: 100%; /* IE 11 flexbox min-height fix */
    width: 100%;
    background-color: ${theme.color.gray10};

    ${$bgColor === "gray" &&
      css`
        background-color: ${theme.color.gray3};
      `}
  `};
`;

const Content = styled.main<{ $variant: PageWrapperLayoutVariant }>`
  ${({ theme, $variant }) => css`
    flex: auto;
    box-sizing: border-box;
    font-size: ${theme.typography.size.m};
    line-height: ${theme.typography.lineHeight.m};
    font-family: ${theme.typography.bodyFamily};
    margin: 0 auto;
    width: 100%;
    padding: ${theme.spacing.s} 0;

    @media screen and (min-width: ${theme.breakpoints.s}) {
      padding: ${theme.spacing.s} ${theme.spacing.m};
    }

    @media screen and (min-width: ${theme.breakpoints.m}) {
      padding: ${theme.spacing.s} ${theme.spacing.xl};
      max-width: ${$variant === "narrow"
        ? `calc(${theme.spacing.xl} * 2 + 600px)`
        : theme.breakpoints.m};
    }
  `};
`;

const PageWrapper = ({
  children,
  header,
  footer,
  bgColor = "white",
  variant = "default"
}: Props) => {
  return (
    <Wrapper $bgColor={bgColor}>
      <header>{header}</header>
      <Content $variant={variant}>{children}</Content>
      <footer>{footer}</footer>
    </Wrapper>
  );
};

export default PageWrapper;
